import { REACT_STORAGE_AUTH_KEY } from '@honeybook/utils-web';
import { BaseHttpClient } from './base-http-client';
/**
 * HTTP client for unauthenticated HoneyBook web surfaces — signup and the CX
 * shell (galleries / floor-plan). There is no user session, so on an HB
 * unauthorized error it clears any locally-stored auth token and reloads (there
 * is no session to recover). This matches the legacy `BaseApiService` behavior
 * these surfaces inherit today.
 *
 * Consume it directly (signup) or subclass it for a non-session divergence
 * (e.g. the CX shell overriding `shouldUseCredentials`). The authenticated
 * counterpart is a separate `BaseHttpClient` subclass, added when the
 * authenticated CX/MX branch lands.
 */
export class UnauthenticatedHttpClient extends BaseHttpClient {
    onUnauthorizedError() {
        try {
            localStorage.removeItem(REACT_STORAGE_AUTH_KEY);
        }
        catch (error) {
            this.logger.error(new Error('Failed to clear the stored auth token', {
                cause: error
            }));
        }
        window.location.reload();
    }
}
//# sourceMappingURL=unauthenticated-http-client.js.map